module.exports = __webpack_public_path__ + "img/cover-promotion-bg-mobile.7993b3a2.png";